export const PASSWORD_LENGTH = 6;
export const emailRegex = /\S+@\S+\.\S+/;
export const FOODS = 'FOODS';
export const DRINKS = 'DRINKS';
export const FIRST_TWELVE = 12;
export const FIRST_FIVE = 5;
export const FIRS_SIX = 6;
export const URL_EMBED = 24;
